export default __webpack_public_path__ + "static/media/calendar.7a92c3d7.svg";